import { broadcast } from 'utils/message'

export const getDriftUrl = async (content: string = '') => {
  const { data: hostLocation = {} } = await broadcast({
    topic: 'access-host-window',
    message: { key: 'location' }
  })

  return `https://drift.com?utm_source=${hostLocation.host}&utm_medium=web-widget&utm_campaign=widget-referral&utm_content=${content}`
}